<template>
  <a-modal ref="noticeDetailx" :width="500" :visible="visible" @cancel="close" :footer="null">
    <template slot="title">
      <center><a-tag color="red">通知</a-tag>{{ messageType | filterDict(newsTypeList) }}</center>
    </template>
    <div class="notice-detail" v-highlight>
      {{ noticeData.messageContent }}
      <router-link
        v-if="messageType === '3' && rentSaleType == '1'"
        @click.native="close"
        class="goList"
        :to="{ name: 'HousesDetails', query: { id: id } }"
      >去跟进
      </router-link>
      <router-link
        v-if="messageType === '3' && rentSaleType == '2'"
        @click.native="close"
        class="goList"
        :to="{ name: 'HousesDetailsSell', query: { id: id } }"
      >去跟进
      </router-link>
      <router-link
        v-if="messageType === '7' && rentSaleType == '1'"
        @click.native="close"
        class="goList"
        :to="{ name: 'TouristDetails', query: { id: id } }"
      >去跟进
      </router-link>
      <router-link
        v-if="messageType === '7' && rentSaleType == '2'"
        @click.native="close"
        class="goList"
        :to="{ name: 'touristSellDetails', query: { id: id } }"
      >去跟进
      </router-link>
      <div class="time">
        {{ noticeData.alertTime }}
      </div>
    </div>
  </a-modal>
</template>

<script>
import { messagesPushRecord } from '@/api/system/notice'

export default {
  name: 'NoticeDetailx',
  components: {},
  props: {
    typeOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      loadingMore: false,
      showLoadingMore: true,
      visible: false,
      noticeData: {},
      messageType: '', // 1"签约喜报"/2"公盘认领审批"/3"房源跟进提醒"/4"房源通知"/5"客源通知"/6生日祝福/7客源跟进提醒
      newsTypeList: [],
      id: '',
      rentSaleType: ''
    }
  },
  methods: {
    /** 修改按钮操作 */
    getNotice (item, index) {
      this.messageType = item.messageType
      this.noticeData = item
      this.rentSaleType = JSON.parse(item.ext.replace(/'\'/g, '')).rentSaleType
      // this.rentSaleType = JSON.parse(item.ext).rentSaleType
      this.id = JSON.parse(item.ext).resourceId

      messagesPushRecord(item.messagesPushRecordId).then((response) => {
        if (response.code === 200) {
           this.$emit('updateMessage')
        }
      })
      this.visible = true

      console.log(this.rentSaleType, this.messageType, 'messageType')
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.noticeData = {}
    }
  },
  created () {
    this.getDicts('message_type').then((response) => {
      // console.log(response, '---------------------------')
      this.newsTypeList = response.data
    })
  }
}
</script>
<style lang="less" scoped>
.notice-detail {
  /* table 样式 */
  /deep/ table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  /deep/ table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  /deep/ table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }

  /* blockquote 样式 */
  /deep/ blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  /* code 样式 */
  /deep/ code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  /deep/ pre code {
    display: block;
  }

  /* ul ol 样式 */
  /deep/ ul,
  ol {
    margin: 10px 0 10px 20px;
  }
  .goList {
    color: var(--ThemeColor);
    cursor: pointer;
  }
}
</style>
